import { Provider } from '@angular/core';
import { APP_CONFIG } from './app-config.token';
import { AppConfig } from './app-config.model';
import { environment } from '@env/environment';

export function provideAppConfig(): Provider {
  const cfg: AppConfig = {
    serviceApiUrl: environment.serviceApiUrl,
    npiApiUrl: environment.npiApiUrl,
  };
  return { provide: APP_CONFIG, useValue: cfg };
}
